// extracted by mini-css-extract-plugin
export default {"Preview":"Preview__coyW4jQMey","Preview--mobile-only":"Preview--mobile-only__fzDWVj3eXQ"};